import React from "react";

import { MONITOR_SCHEDULES } from "src/web/constants";

export const MonitorSchedules: React.FC = () => (
    <dl>
        {MONITOR_SCHEDULES.map((schedule) => (
            <React.Fragment key={schedule.refreshes}>
                <dt>{schedule.refreshes}</dt>
                <dd>
                    <div>{schedule.cadence}</div>
                    <div>{schedule.detail}</div>
                </dd>
            </React.Fragment>
        ))}
    </dl>
);

export default MonitorSchedules;
